import { Chip } from "@mui/material";

const TestCaseChip = ({ small }: { small?: boolean }) => {
  return (
    <Chip
      color="info"
      size={small ? "small" : "medium"}
      label={"Test Case"}
      variant="outlined"
    />
  );
};

export default TestCaseChip;
